'use client'

import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useLocation } from '@marketplace-web/shared/browser'
import { MediaSelectContextProvider } from '@marketplace-web/item-upload/media-upload-feature'
import { useClientSideOnly } from '@marketplace-web/shared/ui-helpers'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { getFaqNotLoggedInEntries } from 'data/api/get-faq-not-logged-in-entries'
import { getTransaction } from 'data/api/get-transaction'

import { FaqEntryModel } from 'types/models/faq-entry'

import ContactForm from './ContactForm'

type Props = {
  faqEntry?: FaqEntryModel
}

const SupportTickets = ({ faqEntry }: Props) => {
  const { faq_entry_id, transaction_id } = useLocation().searchParams

  const transactionId = Number(transaction_id)
  const faqEntityId = Array.isArray(faq_entry_id) ? undefined : faq_entry_id

  const isClientSideRenderReady = useClientSideOnly()

  const {
    fetch: fetchFaqNotLoggedInEntires,
    data: faqNotLoggedInEntriesData,
    isLoading: isFaqNotLoggedInEntriesLoading,
  } = useFetch(getFaqNotLoggedInEntries)

  const {
    fetch: fetchTransaction,
    data: transactionData,
    isLoading: isTransactionLoading,
  } = useFetch(getTransaction)

  useEffect(() => {
    fetchFaqNotLoggedInEntires()
    if (transactionId) fetchTransaction({ id: transactionId })
  }, [faqEntityId, fetchFaqNotLoggedInEntires, fetchTransaction, transactionId])

  const preselectedTransaction = transactionData?.transaction || null

  const isLoginTipDisplayed =
    !faqNotLoggedInEntriesData?.faq_entries.some(({ id }) => id === Number(faqEntityId)) || false

  if (isTransactionLoading || isFaqNotLoggedInEntriesLoading || !isClientSideRenderReady) {
    return (
      <ContentLoader
        styling={ContentLoader.Styling.Wide}
        size={ContentLoader.Size.Large}
        testId="contact-form-loader"
      />
    )
  }

  if (!faqEntry || !faqNotLoggedInEntriesData) return null

  return (
    <MediaSelectContextProvider>
      <ContactForm
        faqEntry={faqEntry}
        isLoginTipDisplayed={isLoginTipDisplayed}
        preselectedTransaction={preselectedTransaction}
        isEnglishAllowedVisible={!!faqEntry.englishAllowedVisible}
        photoEntryId={0}
      />
    </MediaSelectContextProvider>
  )
}

export default SupportTickets
